import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from '../../styles/actionsDropdown.module.css';

const ActionsDropdown = ({ actions, label = 'Acciones' }) => {
    const [open, setOpen] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
    const triggerRef = useRef(null);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                triggerRef.current && !triggerRef.current.contains(e.target) &&
                menuRef.current && !menuRef.current.contains(e.target)
            ) {
                setOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        if (open && triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setMenuPosition({
                top: rect.bottom + 4,
                left: rect.right - 180,
            });
        }
    }, [open]);

    return (
        <>
            <div className={styles.wrap} ref={triggerRef}>
                <button
                    type="button"
                    className={styles.trigger}
                    onClick={() => setOpen(!open)}
                    aria-haspopup="true"
                    aria-expanded={open}
                    aria-label={label}
                >
                    <span className={styles.dots}>⋮</span>
                </button>
            </div>
            {open && createPortal(
                <ul
                    ref={menuRef}
                    className={styles.menu}
                    role="menu"
                    style={{
                        position: 'fixed',
                        top: menuPosition.top,
                        left: menuPosition.left,
                        minWidth: '180px',
                    }}
                >
                    {actions.map((item, i) => (
                        <li key={i} role="none">
                            <button
                                type="button"
                                role="menuitem"
                                className={item.danger ? styles.menuItemDanger : styles.menuItem}
                                onClick={() => {
                                    item.onClick();
                                    setOpen(false);
                                }}
                            >
                                {item.label}
                            </button>
                        </li>
                    ))}
                </ul>,
                document.body
            )}
        </>
    );
};

export default ActionsDropdown;
